import { render } from "./FDEmptyData.vue?vue&type=template&id=0b11b2f2&scoped=true"
import script from "./FDEmptyData.vue?vue&type=script&lang=js"
export * from "./FDEmptyData.vue?vue&type=script&lang=js"

import "./FDEmptyData.vue?vue&type=style&index=0&id=0b11b2f2&scoped=true&lang=css"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b11b2f2"]])

export default __exports__